import { UserException } from '@/domain/user/exception/UserException'

export class InvalidFirstNameException extends UserException {

}
